module.exports = __webpack_public_path__ + "static/img/1111.f785dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1111.png
// module id = XYBo
// module chunks = 1